{
  "09fd2948a8dffd21": "Workplace",
  "0a5d5c335cd87d5f": "Total spend",
  "0cd5e22fc50a93f0": "Worker type",
  "11e9eccfeca65d0b": "Total verified shifts",
  "18086e0b0dca6cea": "PDF (.pdf)",
  "1cfb62875a3f4d2d": "workplaces",
  "28eaf72277d6ddf5": "Couldn't create a share link. Please try again.",
  "2d275a74912cca2e": "Metric",
  "310ca503ef36f177": "Month",
  "324ddac12d893a7d": "Workplaces",
  "354640e37ed70d16": "No analytics are configured.",
  "3664895579f0a7e6": "Export",
  "37e97f978d12dde7": "{{title}} donut chart with {{count}} segments",
  "402e15bc3f9dc45e": "Something went wrong loading this metric.",
  "45a82a5b34e749f0": "Excel (.xlsx)",
  "494ca78f7374e46f": "Custom",
  "49c6f4121e8dc55c": "Generated at",
  "4c6ad06c67817871": "This shared link is no longer available",
  "54a00fd5f7c2e9eb": "Totals by {{groupBy}}",
  "5822754796c65d5b": "Last year",
  "5bc86dc5fdf8f13e": "Couldn't export analytics. Please try again.",
  "6a00dfc1dc867e84": "Monday",
  "6dde11117000cc15": "Applied filters",
  "6e795d4d3cc21c5c": "Period",
  "757fd1902294c03e": "Year to date",
  "78963905f399ce6f": "Dates",
  "7d8af1de1262f150": "Tuesday",
  "7ff2bc6248f6e1a0": "Shared view · expires {{expiresLabel}}",
  "8061bfb29ce82f35": "Date range",
  "873fef760e5d001b": "Sunday",
  "8e37953d23daca5f": "Value",
  "8e76a94ac8320d51": "Summary",
  "8ea2a7069338c8de": "Date preset",
  "8f2364e11b8be3ff": "Day",
  "94c116ee118a7299": "Analytics",
  "956a51f6b098a41b": "Group by",
  "9902d7ae89e288fb": "Last 90 days",
  "99e928001739da35": "Hours over time",
  "9f944f379810ac3c": "{{title}} chart with {{count}} series",
  "9f987627b99b3081": "All workplaces",
  "a2dd9cbb7013bb70": "Exporting…",
  "a3b50c476732c740": "State",
  "a59ac4901542233d": "{{title}} breakdown",
  "a757b228061803e1": "Day of week",
  "b474b39788978476": "Quarter",
  "b4f514f87ca5372b": "Fill rate over time",
  "bab37d62472990c0": "See more",
  "c0a6cc829cd08735": "Wednesday",
  "c394113333747fff": "No data for selected filters",
  "c91b8ee8b811fb34": "Fill rate",
  "c9b3c38247f744e1": "Total",
  "cc29e6034aae6d05": "The link may have expired or been revoked. Ask the sender for a new share link.",
  "d0a4d1e4d6f27b61": "Shift type",
  "d31483e209cd5b1d": "Copy share link",
  "d44c66e04b73c73f": "Spend over time",
  "d6f2087fcd8a6070": "Time bucket",
  "db67c5f84d851ae6": "Total hours",
  "dbe17b25fc97a7d2": "{{count}} metrics configured.",
  "dbe35c7363c2f7ec": "Saturday",
  "e1c13b7cff3c6d53": "Verified shifts over time",
  "e21f3f372a46d4be": "Friday",
  "e2659de0c3e0ef69": "No data for the selected filters.",
  "e473c8ef4e0d4ee1": "Quarter to date",
  "e72a1aedfa29ad42": "Share link copied to clipboard",
  "e78041ab51a818a2": "Week",
  "e8233a146856d5b1": "{{count}} metric configured.",
  "e8ce3af01c672628": "Created the share link, but couldn't copy it. Please try again.",
  "ea1debccad839065": "Number of unique professionals",
  "f8f03fb441b8b4ae": "Last 30 days",
  "f97e9da0e3b879f0": "Other",
  "fc2662062ffdef96": "Thursday"
}
